// converts products to array, unless it is comingSoon or strings like order and textOverlay
// deletes comingSoon completely if the date is not there
// for comingSoon, mark as expired if the date has passed
export function handleProducts(obj) {
	Object.keys(obj).forEach((format) => {
		Object.keys(obj[format]).forEach((merchant) => {
			Object.keys(obj[format][merchant]).forEach((avail) => {
				const remindMeDateGMT = new Date(obj[format][merchant][avail].date);
				const remindMeDateLocal = new Date(remindMeDateGMT.getTime() - remindMeDateGMT.getTimezoneOffset() * -60000 );
				if (!obj[format][merchant][avail] || typeof obj[format][merchant][avail] !== 'object') {
					return;
				}
				if (avail !== 'comingSoon') {
					obj[format][merchant][avail] = Object.values(obj[format][merchant][avail]);
				} else if (!obj[format][merchant][avail].date) {
					delete obj[format][merchant][avail];
				} else if (new Date() > remindMeDateLocal) {
					obj[format][merchant][avail].expired = true;
				}
			});
		});
	});

	return obj;
}

export function checkMerchantRegionalLogo(merchant, region) {
	const merchantsWithRegionalLogo = {
		br: ['appletvapp', 'googleplay'],
		ca_fr: ['appletvapp', 'googleplay'],
		de: ['appletvapp', 'googleplay'],
		es: ['appletvapp', 'googleplay'],
		fr: ['appletvapp', 'cineplexstore', 'googleplay', 'videotron'],
		it: ['appletvapp', 'googleplay'],
		nl: ['appletvapp', 'googleplay'],
		pt: ['appletvapp', 'googleplay'],
		tw: ['appletvapp', 'googleplay']
	};

	if (!merchantsWithRegionalLogo[region]) {
		return false;
	}

	return merchantsWithRegionalLogo[region].includes(merchant);
}
